<template>
    <div>
        <v-icon
            :color="value ? 'primary' : 'secondary-lighten-3'"
            size="18"
        >
            {{ icon }}
        </v-icon>
    </div>
</template>

<script>
export default {
    name: "PDispositionStatus",

    props: {
        value: {

        },

        icon: {

        }
    }
}
</script>

<style scoped>

</style>
